import * as types from '../actions/types';

const initialState = {
    page: 1,
    success: false
}

export default function FaqPageReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.PAGE_FAQ:
            return {
                page: action.payload,
                success: false
            }
        default:
            return state
    }
}
